import { BaseRepository } from "@features/shared/data";
import type {
  MerchantTierInfoEntity,
  MerchantTiersEntity,
  TierEntity,
  TieringRepositoryContract,
} from "@features/tiering/domain";
import { TIERING_API } from "../constants";
import { mapMerchantTierInfo, mapMerchantTiers } from "../mappers";
import { type MerchantTierInfoModel } from "../models";

export class TieringRepository
  extends BaseRepository
  implements TieringRepositoryContract
{
  /**
   * Get all tiers
   */
  public async list(): Promise<TierEntity[]> {
    return this.runtimeCacheable("tiering.list", async () => {
      const response = await this.http.get<TierEntity[]>(TIERING_API.TIERS);

      return response.data;
    });
  }

  /**
   * Get merchant current tier info
   */
  public async merchantTierInfo(): Promise<MerchantTierInfoEntity> {
    return this.runtimeCacheable("tiering.merchantTierInfo", async () => {
      const response = await this.http.get<MerchantTierInfoModel>(
        TIERING_API.MERCHANT_TIER_INFO,
      );

      return mapMerchantTierInfo(response.data);
    });
  }

  /**
   * Get merchant tiers along with merchant info
   */
  public async merchantTiers(): Promise<MerchantTiersEntity> {
    const [tiers, merchantTierInfo] = await Promise.all([
      this.list(),
      this.merchantTierInfo(),
    ]);

    return mapMerchantTiers(tiers, merchantTierInfo);
  }
}
